import { Routes, Route } from "react-router-dom";
import React, { useEffect, lazy } from "react";
import '@syncfusion/ej2-base/styles/material.css';       // Base styles including icons
import '@syncfusion/ej2-buttons/styles/material.css';
import '@syncfusion/ej2-calendars/styles/material.css';
import '@syncfusion/ej2-dropdowns/styles/material.css';
import '@syncfusion/ej2-inputs/styles/material.css';
import '@syncfusion/ej2-navigations/styles/material.css';
import '@syncfusion/ej2-popups/styles/material.css';
import '@syncfusion/ej2-react-schedule/styles/material.css';
import { loadScript } from "../Helpers/utils/loadScript";

const StudentSettings = lazy(() => import("../Pages/Settings/Settings"));
const EnrolledCourses = lazy(() => import("../Pages/EnrolledCourses/EnrolledCourses"));
const CompletedCourses = lazy(() => import("../Pages/EnrolledCourses/CompletedCourses"));
const StudentConversation = lazy(() =>import("../Pages/Conversation/StudentCoversation"));
const CourseEnrollment = lazy(() => import("../Pages/CourseEnrollment/CourseEnrollment"));
const WishList = lazy(() => import("../Pages/WishList/WishList"));
const Ratings = lazy(() => import("../Pages/Ratings/Ratings"));
const EnrolledCourseFeedback = lazy(() => import("../Pages/EnrolledCourseFeedBack/EnrolledCourseFeedback"));
const CourseCompletionCertificate = lazy(() =>import("../Pages/CourseCompletionCertificate/CourseCompletionCertificate"));
const VerifyCertificate = lazy(() =>import("../Pages/VerifyCertificate/VerifyCertificate"));
const TrackInstructorLocation = lazy(() =>import("../Pages/TrackInstructorLocation/TrackInstructorLocation"));
const InstituteLocation = lazy(() => import("../Pages/InstituteLocation/InstituteLocation"));
const EnrolledCourseInstituteDetails = lazy(() => import("../Pages/EnrolledCourses/InstituteDetails/InstituteDetails"));
const PaymentDetails = lazy(() => import("../Pages/PaymentDetails/PaymentDetails"));
const PaymentInstallmentsInvoice = lazy(() => import("../Pages/PaymentInvoice/PaymentInvoice"));
const PickupService = lazy(() => import("../Pages/PickupService/PickupSevice"));
const SEnrolledCourse = lazy(() => import("../Pages/SingleEnrolledCourse/SingleEnrolledCourse"));
const CourseProgress = lazy(() => import("../Pages/CourseProgress/CourseProgress"));
const ClassesSchedule = lazy(() =>import("../Pages/ClassesSchedule (For Student)/ClassesSchedule"));
const EnrolledCourseLearnerInformation = lazy(() => import("../Pages/EnrolledCourseLearnerInformation/EnrolledCourseLearnerInformation"));

const LearnerRoutes = () => (
  <React.Fragment>
    <Route path="/student/settings" element={<StudentSettings />} />
    <Route path="/mycourses/enrolledcourses" element={<EnrolledCourses />} />
    <Route path="/mycourses/completedcourses" element={<CompletedCourses />} />
    <Route path="/student/inbox" element={<StudentConversation />} />
    <Route path="/Enrollment/Course" element={<CourseEnrollment />} />
    <Route path="/Wishlist" element={<WishList />} />
    <Route path="/mycourses/Wishlist" element={<WishList />} />
    <Route path="/feedback" element={<Ratings />} />
    <Route path="/enrolledcourse/feedback/:EnrollmentId" element={<EnrolledCourseFeedback />} />
    <Route path="/enrolledcourse/certificate" element={<CourseCompletionCertificate />} />
    <Route path="/verifycertificate/:CertificateId" element={<VerifyCertificate />} />
    <Route path="/track-instructor-location/:EnrollmentId" element={<TrackInstructorLocation />} />
    <Route path="/enrolledcourse/institutelocation/:InstituteId" element={<InstituteLocation />} />
    <Route path="/enrolledcourse/pickupstudent/:EnrollmentId" element={<PickupService />} />
    <Route path="/enrolledcourse/progress/:EnrollmentId" element={<CourseProgress />} />
    <Route path="/enrolledcourse/paymentdetails/:EnrollmentId" element={<PaymentDetails />} />
    <Route path="/enrolledcourse/paymentdetails/invoice/:paymentId" element={<PaymentInstallmentsInvoice />} />
    <Route path="/enrolledcourse/coursemodule/:EnrollmentId" element={<SEnrolledCourse />} />
    <Route path="/enrolledcourse/aboutinstitute" element={<EnrolledCourseInstituteDetails />} />
    <Route path="/enrolledcourse/upcomingclasses/:EnrollmentId" element={<ClassesSchedule />} />
    <Route path="/enrolledcourse/learnerinfo" element={<EnrolledCourseLearnerInformation />} />
  </React.Fragment>
);
// const LearnerRoutes = () => {

//   return (
//   <Routes>
//     <Route path="/student/settings" element={<StudentSettings />} />
//     <Route path="/mycourses/enrolledcourses" element={<EnrolledCourses />} />
//     <Route path="/mycourses/completedcourses" element={<CompletedCourses />} />
//     <Route path="/student/inbox" element={<StudentConversation  />} />
//     <Route path="/Enrollment/Course" element={<CourseEnrollment />} />
//     <Route path="/Wishlist" element={<WishList />} />
//     <Route path="/mycourses/Wishlist" element={<WishList />} />
//     <Route path="/feedback" element={<Ratings />} />
    
//     <Route path="/enrolledcourse/feedback/:EnrollmentId" element={<EnrolledCourseFeedback />}/>
//     <Route path="/enrolledcourse/certificate" element={<CourseCompletionCertificate />}/>
//     <Route path="/verifycertificate/:CertificateId" element={<VerifyCertificate />}/>
//     <Route path="/track-instructor-location/:EnrollmentId" element={<TrackInstructorLocation />}/>
    
//     <Route path="/enrolledcourse/institutelocation/:InstituteId" element={<InstituteLocation /> }/>
//     <Route path="/enrolledcourse/pickupstudent/:EnrollmentId" element={<PickupService />}/>
//     <Route path="/enrolledcourse/progress/:EnrollmentId" element={<CourseProgress />}/>
//     <Route path="/enrolledcourse/paymentdetails/:EnrollmentId" element={<PaymentDetails />}/>
//     <Route path="/enrolledcourse/paymentdetails/invoice/:paymentId" element={<PaymentInstallmentsInvoice />}/>
//     <Route path="/enrolledcourse/coursemodule/:EnrollmentId" element={<SEnrolledCourse />}/>
//     <Route path="/enrolledcourse/aboutinstitute" element={<EnrolledCourseInstituteDetails />}/>
//     <Route path="/enrolledcourse/upcomingclasses/:EnrollmentId" element={<ClassesSchedule />}/> 
//     <Route path="/enrolledcourse/learnerinfo" element={<EnrolledCourseLearnerInformation />}/>
       
//   </Routes>
//   )
// };

export default LearnerRoutes;
